import { render, staticRenderFns } from "./main.vue?vue&type=template&id=01c5fc82&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5fc82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01c5fc82')) {
      api.createRecord('01c5fc82', component.options)
    } else {
      api.reload('01c5fc82', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=01c5fc82&scoped=true", function () {
      api.rerender('01c5fc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/masters/schedule/components/modal/main.vue"
export default component.exports